import React, { useState, useEffect, useRef } from 'react';
import { Fecha } from '../../../componentes/Fecha'
import { TextField, Box } from "@material-ui/core";
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { Button, Option, Select, Typography } from '@material-tailwind/react';
import { esMayor, fechasEstaIncluida } from '../../../Helpers/fechas';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export const Cabecera = ({ 
    setFechaDesde,
    setFechaHasta,
    filtrarLista,
    usuario,
    regiones,
    parametros,
    setNombre,
    handleChangeSelectRegion,
    regionSeleccionada  // el listado se filtra y se resetea en el comp padre porque los datos se comparten con otros componentes
}) => {

    //const [textoNombre, setTextoNombre] = useState("");
    const { esCelular } = useContextoGlobal();

    const handleChangeInputNombre = (e) => {
       // setTextoNombre(e.target.value)
        setNombre(e.target.value)
    }

    //  const handleSearchData = () => {
    //     const callback = (item) =>
    //     item.contribuyente?.toUpperCase().includes(textoNombre.toUpperCase()) ||
    //     item.titular?.toUpperCase().includes(textoNombre.toUpperCase())

    //     // el listado se filtra y se resetea en el comp padre porque los datos se comparten con otros componentes
    //     filtrarLista(callback)
    // };

     const handleSearchData = () => {
        const callback = (item) =>
        item.contribuyente?.toUpperCase().includes(parametros?.nombre.toUpperCase()) ||
        item.titular?.toUpperCase().includes(parametros?.nombre.toUpperCase())

        // el listado se filtra y se resetea en el comp padre porque los datos se comparten con otros componentes
        filtrarLista(callback)
    };

    return <div className='flex f-col mt-4'>
        <div className={`flex ${esCelular ? 'f-col space-y-2 items-center' : 'f-row space-x-4'} justify-center flex-wrap abc`}>
            {usuario.sede_admin && <SeleccionadorXLabel titulo='Región'
                vector={regiones}
                onchange={handleChangeSelectRegion}
                claves={{ id: 'id_region', nombre: 'nombre' }}
                valor={regionSeleccionada}
                nombre='Seleccione una región'
            />
            }
            <div>
                <Typography
                    variant="small"
                    className="mb-1 font-medium "
                >
                    Fecha Desde
                </Typography>
                {/* <Fecha fecha={fechaDesde} setFecha={setFechaDesde} /> */}
                <Fecha fecha={parametros.fechaDesde} setFecha={setFechaDesde} />
            </div>
            <div>
                <Typography
                    variant="small"
                    className="mb-1 font-medium "
                >
                    Fecha Hasta
                </Typography>
                {/* <Fecha fecha={fechaHasta} setFecha={setFechaHasta} /> */}
                <Fecha fecha={parametros.fechaHasta} setFecha={setFechaHasta} />
            </div>
            <Box sx={{}}>
                <Typography
                    variant="small"
                    className="mb-1 font-medium "
                >
                    Nombre
                </Typography>
                {/* <TextField fullWidth id="texto-nombre" inputProps={{}} value={textoNombre} onChange={handleChangeInputNombre} variant="outlined" /> */}
                <TextField fullWidth id="texto-nombre" inputProps={{}} value={parametros.nombre} onChange={handleChangeInputNombre} variant="outlined" />
            </Box>
               <div>
                <Button
                    size="lg"
                    color="blue"
                    className="rounded flex mt-[28px]"
                    onClick={handleSearchData}
                >
                    <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Buscar
                </Button>
            </div>
        </div>
    </div>
}


const SeleccionadorXLabel = ({ vector, onchange, valor, nombre, limpiar, claves, titulo, noDefault }) => {

    return <div className='select-ui-data mb-3'>
        <Typography
            variant="small"
            className="mb-1 font-medium "
        >
            {titulo}
        </Typography>
        <Select
            label="Seleccione una opción"
            value={valor}
            onChange={onchange}
            className='h-14'
        >
            {vector.map((item, index) => (
                <Option key={index} value={item.id_region}>
                    {item.nombre}
                </Option>
            ))}
        </Select>
    </div>
}

